import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProject } from '../../api/apiProjects';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useUpdateProject = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateProjectMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateProject(id, data),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            queryClient.invalidateQueries({ queryKey: ['project'] });
            toast.success(data.message || 'Project updated successfully');
            navigate('/projects');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to update project');
        },
    });

    return {
        updateProjectMutate,
        isPending,
    };
};